import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import { routePermissions } from './config/routePermissions'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Personnel from './pages/Personnel'
import GuardOperations from './pages/GuardOperations'
import Finance from './pages/Finance'
import ReportModule from './components/finance/ReportModule';
import Records from './pages/Records'
import SupplyChain from './pages/SupplyChain'
import RecordPull from './components/recordpull/RecordPull'
import ClientArea from './components/clientarea/ClientArea'
import OffDuty from './components/offduty/OffDuty'
import AdvancePayment from './components/advance-payment/AdvancePayment'
import PayrollModule from './components/finance/PayrollModule';
import Administration from './pages/Administration'
import NotFound from './pages/NotFound'

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, isAuthenticated } = useAuthStore()

  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (allowedRoles && !allowedRoles.includes(user?.role)) return <Navigate to="/dashboard" replace />
  return children
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/personnel" element={<ProtectedRoute allowedRoles={routePermissions['/personnel']}><Personnel /></ProtectedRoute>} />
        <Route path="/guard-operations" element={<ProtectedRoute allowedRoles={routePermissions['/guard-operations']}><GuardOperations /></ProtectedRoute>} />
        <Route path="/finance" element={<ProtectedRoute allowedRoles={routePermissions['/finance']}><Finance /></ProtectedRoute>} />
        <Route path="/finance/reports" element={<ProtectedRoute allowedRoles={routePermissions['/finance']}><ReportModule /></ProtectedRoute>} />
        <Route path="/records" element={<ProtectedRoute allowedRoles={routePermissions['/records']}><Records /></ProtectedRoute>} />
        <Route path="/supply-chain" element={<ProtectedRoute allowedRoles={routePermissions['/supply-chain']}><SupplyChain /></ProtectedRoute>} />
        <Route path="/record-pull" element={<ProtectedRoute allowedRoles={routePermissions['/record-pull']}><RecordPull /></ProtectedRoute>} />
        <Route path="/client-area" element={<ProtectedRoute allowedRoles={routePermissions['/client-area']}><ClientArea /></ProtectedRoute>} />
        <Route path="/off-duty" element={<ProtectedRoute allowedRoles={routePermissions['/off-duty']}><OffDuty /></ProtectedRoute>} />
        <Route path="/advance-payments" element={<ProtectedRoute allowedRoles={routePermissions['/advance-payments'] || ['admin','supervisor','hr','finance','assistant_hr']}><AdvancePayment /></ProtectedRoute>} />
        <Route path="/payroll" element={<ProtectedRoute allowedRoles={routePermissions['/payroll']}><PayrollModule /></ProtectedRoute>} />
        <Route path="/administration" element={<ProtectedRoute allowedRoles={routePermissions['/administration']}><Administration /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App
